import React, { useEffect, useState } from "react";
import { Modal, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ProductZoom from "../../components/ProductZoom";
import CloseIcon from "@mui/icons-material/Close";
import {
  useLazyGetCityLocationQuery,
  useLazyGetStateCitiesQuery,
  useLazyPropertyCreateQuery,
  usePropertyAddMutation,
  useLazyPropertyShowQuery,
  useLazyPropertyDeleteQuery,
  usePropertyImgUpdateMutation,
  usePropertyUpdateMutation,
} from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import TopHeader from "../Dashoboard/TopHeader";
import { FiEdit } from "react-icons/fi";
import { TiDeleteOutline } from "react-icons/ti";

const PropertyRequestPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const types = location?.state?.type;

  const [createList, setCreateList] = useState({});
  const [cityList, setCityList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [owner_id, setowner_id] = useState("");
  const [category_id, setcategory_idd] = useState("");
  const [state_id, setstate_id] = useState("");
  const [city_id, setcity_id] = useState("");
  const [location_id, setlocation_id] = useState("");
  const [amenities, setamenities] = useState([]);
  const [street, setstreet] = useState("");
  const [apartment, setapartment] = useState("");
  const [block_no, setblock_no] = useState("");
  const [door_no, setdoor_no] = useState("");
  const [pin_code, setpin_code] = useState("");
  const [landmark, setlandmark] = useState("");
  const [latitude, setlatitude] = useState("");
  const [longitude, setlongitude] = useState("");
  const [description, setdescription] = useState("");
  const [short_notes, setshort_notes] = useState("");
  const [policy_rules, setpolicy_rules] = useState("");
  const [couple_friendly, setcouple_friendly] = useState(0);
  const [family_friendly, setfamily_friendly] = useState(0);
  const [name, setname] = useState("");
  const [images, setimages] = useState([]);
  const [imagesErr, setimagesErr] = useState(false);
  const [img, setImg] = useState("");
  const [imgErr, setImgErr] = useState(false);

  const [owner_idErr, setowner_idErr] = useState(false);
  const [category_idErr, setcategory_iddErr] = useState(false);
  const [state_idErr, setstate_idErr] = useState(false);
  const [city_idErr, setcity_idErr] = useState(false);
  const [location_idErr, setlocation_idErr] = useState(false);
  const [amenitiesErr, setamenitiesErr] = useState(false);
  const [streetErr, setstreetErr] = useState(false);
  const [apartmentErr, setapartmentErr] = useState(false);
  const [block_noErr, setblock_noErr] = useState(false);
  const [door_noErr, setdoor_noErr] = useState(false);
  const [pin_codeErr, setpin_codeErr] = useState(false);
  const [landmarkErr, setlandmarkErr] = useState(false);
  const [latitudeErr, setlatitudeErr] = useState(false);
  const [longitudeErr, setlongitudeErr] = useState(false);
  const [descriptionErr, setdescriptionErr] = useState(false);
  const [short_notesErr, setshort_notesErr] = useState(false);
  const [policy_rulesErr, setpolicy_rulesErr] = useState(false);
  const [couple_friendlyErr, setcouple_friendlyErr] = useState(false);
  const [family_friendlyErr, setfamily_friendlyErr] = useState(false);
  const [nameErr, setnameErr] = useState(false);
  const [btn, setBtn] = useState(false);

  const [multiImg, setMultiImg] = useState([]);
  const [singleImg, setSingleImg] = useState("");
  const [modal, setModal] = useState(false);

  // RTK QUERY
  const [propertyCreateApi] = useLazyPropertyCreateQuery();
  const [getStateCitiesApi] = useLazyGetStateCitiesQuery();
  const [getCityLocationApi] = useLazyGetCityLocationQuery();
  const [propertyAddApi] = usePropertyAddMutation();
  const [viewAPI] = useLazyPropertyShowQuery();
  const [deleteAPI] = useLazyPropertyDeleteQuery();
  const [propertyImgUpdateApi] = usePropertyImgUpdateMutation();
  const [propertyUpdateApi] = usePropertyUpdateMutation();

  const getPropertyCreate = () => {
    propertyCreateApi()
      .unwrap()
      .then((res) => {
        setCreateList(res);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getPropertyCreate();
  }, []);

  const handleImages = (value) => {
    let temp = [];
    temp.push(value);
    setimages(temp);
  };

  const handleCheckbok = (type) => {
    if (type == 1) {
      if (couple_friendly == 0) {
        setcouple_friendly(1);
      } else {
        setcouple_friendly(0);
      }
    } else if (type == 2) {
      if (family_friendly == 0) {
        setfamily_friendly(1);
      } else {
        setfamily_friendly(0);
      }
    }
  };

  const getCities = (id) => {
    getStateCitiesApi(id)
      .unwrap()
      .then((res) => {
        setstate_id(id);
        setCityList(res?.cities);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getLocation = (id) => {
    getCityLocationApi(id)
      .unwrap()
      .then((res) => {
        setcity_id(id);
        setLocationList(res?.locations);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const submitHandler = () => {
    if (
      owner_id?.length == 0 ||
      category_id?.length == 0 ||
      state_id?.length == 0 ||
      name?.length == 0 ||
      (types !== "edit" && images?.length == 0) ||
      street?.length == 0 ||
      apartment?.length == 0 ||
      block_no?.length == 0 ||
      door_no?.length == 0 ||
      pin_code?.length == 0 ||
      landmark?.length == 0 ||
      latitude?.length == 0 ||
      longitude?.length == 0 ||
      city_id?.length == 0 ||
      location_id?.length == 0 ||
      amenities?.length == 0 ||
      description?.length == 0 ||
      short_notes?.length == 0 ||
      policy_rules?.length == 0
    ) {
      setowner_idErr(true);
      setcategory_iddErr(true);
      setstate_idErr(true);
      setnameErr(true);
      setstreetErr(true);
      setapartmentErr(true);
      setblock_noErr(true);
      setdoor_noErr(true);
      setpin_codeErr(true);
      setlandmarkErr(true);
      setlatitudeErr(true);
      setlocation_idErr(true);
      setcity_idErr(true);
      setlongitudeErr(true);
      setamenitiesErr(true);
      setdescriptionErr(true);
      setshort_notesErr(true);
      setpolicy_rulesErr(true);
      if (types !== "edit") {
        setimagesErr(true);
      }
    } else {
      const formdata = new FormData();
      formdata.append("owner_id", owner_id);
      formdata.append("category_id", category_id);
      formdata.append("state_id", state_id);
      formdata.append("city_id", city_id);
      formdata.append("location_id", location_id);
      formdata.append("name", name);

      if (images?.length > 0) {
        for (var k = 0; k < images[0].length; k++) {
          if (images[0][k].name) {
            formdata.append("images[" + k + "]", images[0][k]);
          }
        }
      }
      formdata.append("amenities", amenities.toString());
      formdata.append("street", street);
      formdata.append("apartment", apartment);
      formdata.append("block_no", block_no);
      formdata.append("door_no", door_no);
      formdata.append("pin_code", pin_code);
      formdata.append("landmark", landmark);
      formdata.append("latitude", latitude);
      formdata.append("longitude", longitude);
      formdata.append("description", description);
      formdata.append("short_notes", short_notes);
      formdata.append("policy_rules", policy_rules);

      if (couple_friendly == 1) {
        formdata.append("couple_friendly", couple_friendly);
      } else {
        formdata.append("couple_friendly", 0);
      }
      if (family_friendly == 1) {
        formdata.append("family_friendly", family_friendly);
      } else {
        formdata.append("family_friendly", 0);
      }

      if (types == "edit") {
        dispatch(saveLoader(true));
        setBtn(true);
        formdata.append("_method", "PUT");
        propertyUpdateApi({ payload: formdata, id: location?.state?.data?.id })
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                text: res?.message,
                icon: "success",
              });
              navigate(-1);
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.log("err", err);
          });
      } else {
        dispatch(saveLoader(true));
        setBtn(true);
        propertyAddApi(formdata)
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                text: res?.message,
                icon: "success",
              });
              navigate(-1);
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.log("err", err);
          });
      }
    }
  };

  const handleChange = (selectedItems) => {
    let flavors = [];
    for (let i = 0; i < selectedItems.length; i++) {
      flavors.push(selectedItems[i].value);
    }
    setamenities(flavors);
  };

  const getView = () => {
    dispatch(saveLoader(true));
    viewAPI(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        let data = res?.property;
        if (data?.owner?.id) {
          setowner_id(data?.owner?.id);
        }

        if (data?.category?.id) {
          setcategory_idd(data?.category?.id);
        }

        if (data?.state?.id) {
          getCities(data?.state?.id);
          setstate_id(data?.state?.id);
        }

        if (data?.city?.id) {
          getLocation(data?.city?.id);
          setcity_id(data?.city?.id);
        }

        if (data?.location?.id) {
          setlocation_id(data?.location?.id);
        }

        if (data?.name) {
          setname(data?.name);
        }

        if (data?.street) {
          setstreet(data?.street);
        }

        if (data?.apartment) {
          setapartment(data?.apartment);
        }

        if (data?.block) {
          setblock_no(data?.block);
        }

        if (data?.door_no) {
          setdoor_no(data?.door_no);
        }

        if (data?.pincode) {
          setpin_code(data?.pincode);
        }

        if (data?.landmark) {
          setlandmark(data?.landmark);
        }

        if (data?.latitude) {
          setlatitude(data?.latitude);
        }

        if (data?.longitude) {
          setlongitude(data?.longitude);
        }

        if (data?.decscription) {
          setdescription(data?.decscription);
        }

        if (data?.short_notes) {
          setshort_notes(data?.short_notes);
        }

        if (data?.policy_rules) {
          setpolicy_rules(data?.policy_rules);
        }

        if (data?.policy_rules) {
          setpolicy_rules(data?.policy_rules);
        }

        if (data?.couple_friendly) {
          setcouple_friendly(data?.couple_friendly);
        }

        if (data?.family_friendly) {
          setfamily_friendly(data?.family_friendly);
        }

        if (data?.image) {
          setSingleImg(data?.image);
        }

        setMultiImg(data?.images);

        let amenities_ = [];

        res?.amenities?.map((item, ind) => {
          amenities_.push(item?.id);
        });

        setamenities(amenities_);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getView();
    }
  }, []);

  const deleteFun = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(saveLoader(true));
        setBtn(true);
        deleteAPI(id)
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                title: "Deleted!",
                text: "Your file has been deleted.",
                icon: "success",
              });
              getView();
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.log("err", err);
          });
      }
    });
  };

  const saveImg = () => {
    if (img?.length == 0) {
      setImgErr(true);
    } else {
      const formdata = new FormData();
      formdata.append("image", img);
      formdata.append("property_id", location?.state?.data?.id);

      dispatch(saveLoader(true));
      setBtn(true);
      propertyImgUpdateApi(formdata)
        .unwrap()
        .then((res) => {
          dispatch(saveLoader(false));
          setBtn(false);
          if (res?.status == "success") {
            Swal.fire({
              text: res?.message,
              icon: "success",
            });
            setModal(false);
            getView();
          }
        })
        .catch((err) => {
          dispatch(saveLoader(false));
          setBtn(false);
          console.log("err", err);
        });
    }
  };

  return (
    <div className="dashRightView home_section">
      <TopHeader type={types == "edit" ? "edit-property" : "property"} />
      <div className="mt-4 block block-rounded ">
        <div className="block-content">
          <Row>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Property Owners
                </label>
                <select
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setowner_id(e.target.value)}
                  value={owner_id}
                >
                  <option value={""} disabled>
                    Select Owners
                  </option>
                  {createList?.owners?.map((item, ind) => {
                    return (
                      <option value={item?.id} key={ind}>
                        {item?.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              {owner_id?.length == 0 && owner_idErr && (
                <p className="err">Select Owners</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Hotel Category
                </label>
                <select
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setcategory_idd(e.target.value)}
                  value={category_id}
                >
                  <option value={""} disabled>
                    Select Hotel Category
                  </option>
                  {createList?.categories?.map((item, ind) => {
                    return (
                      <option value={item?.id} key={ind}>
                        {item?.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              {category_id?.length == 0 && category_idErr && (
                <p className="err">Select Hotel Category</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  State
                </label>
                <select
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => getCities(e.target.value)}
                  value={state_id}
                >
                  <option value={""} disabled>
                    Select State
                  </option>
                  {createList?.states?.map((item, ind) => {
                    return (
                      <option value={item?.id} key={ind}>
                        {item?.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              {state_id?.length == 0 && state_idErr && (
                <p className="err">Select State</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  City
                </label>
                <select
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => getLocation(e.target.value)}
                  value={city_id}
                >
                  <option value={""} disabled>
                    Select City
                  </option>
                  {cityList?.map((item, ind) => {
                    return (
                      <option value={item?.id} key={ind}>
                        {item?.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              {city_id?.length == 0 && city_idErr && (
                <p className="err">Select City</p>
              )}
            </div>

            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Location
                </label>
                <select
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setlocation_id(e.target.value)}
                  value={location_id}
                >
                  <option value={""} disabled>
                    Select Location
                  </option>
                  {locationList?.map((item, ind) => {
                    return (
                      <option value={item?.id} key={ind}>
                        {item?.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              {location_id?.length == 0 && location_idErr && (
                <p className="err">Select Location</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Property Name
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setname(e.target.value)}
                  value={name}
                />
              </div>
              {name?.length == 0 && nameErr && (
                <p className="err">Enter Name</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Upload Images 307 X 207 (pixel)
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => handleImages(e.target.files)}
                  type={"file"}
                  accept="image/jpeg, image/png"
                  multiple
                />
              </div>
              {images?.length == 0 && imagesErr && (
                <p className="err">Upload Images</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Street
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setstreet(e.target.value)}
                  value={street}
                />
              </div>
              {street?.length == 0 && streetErr && (
                <p className="err">Enter Street</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Appartment
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setapartment(e.target.value)}
                  value={apartment}
                />
              </div>
              {apartment?.length == 0 && apartmentErr && (
                <p className="err">Enter Appartment</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Block Floor
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setblock_no(e.target.value)}
                  value={block_no}
                />
              </div>
              {block_no?.length == 0 && block_noErr && (
                <p className="err">Enter Block Floor</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Door No
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setdoor_no(e.target.value)}
                  value={door_no}
                />
              </div>
              {door_no?.length == 0 && door_noErr && (
                <p className="err">Enter Door No</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Pincode
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setpin_code(e.target.value)}
                  value={pin_code}
                  type="number"
                />
              </div>
              {pin_code?.length == 0 && pin_codeErr && (
                <p className="err">Enter Pincode</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Landmark
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setlandmark(e.target.value)}
                  value={landmark}
                />
              </div>
              {landmark?.length == 0 && landmarkErr && (
                <p className="err">Enter Landmark</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Latitude
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setlatitude(e.target.value)}
                  value={latitude}
                  type="number"
                />
              </div>
              {latitude?.length == 0 && latitudeErr && (
                <p className="err">Enter Latitude</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Longitude
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setlongitude(e.target.value)}
                  value={longitude}
                  type="number"
                />
              </div>
              {longitude?.length == 0 && longitudeErr && (
                <p className="err">Enter Longitude</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Amenities
                </label>
                <select
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => handleChange(e.target.selectedOptions)}
                  value={amenities}
                  // defaultValue={amenities}
                  multiple={true}
                  size={4}
                >
                  {createList?.amenities?.map((item, ind) => {
                    return (
                      <option value={item?.id} key={ind}>
                        {item?.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              {amenities?.length == 0 && amenitiesErr && (
                <p className="err">Select Amenities</p>
              )}
            </div>

            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Description
                </label>
                <textarea
                  rows={3}
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setdescription(e.target.value)}
                  value={description}
                />
              </div>
              {description?.length == 0 && descriptionErr && (
                <p className="err">Enter Description</p>
              )}
            </div>

            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Short Notes
                </label>
                <textarea
                  rows={3}
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setshort_notes(e.target.value)}
                  value={short_notes}
                />
              </div>
              {short_notes?.length == 0 && short_notesErr && (
                <p className="err">Enter Short Notes</p>
              )}
            </div>

            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Policy Rules
                </label>
                <textarea
                  rows={3}
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setpolicy_rules(e.target.value)}
                  value={policy_rules}
                />
              </div>
              {policy_rules?.length == 0 && policy_rulesErr && (
                <p className="err">Enter Policy Rules</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group d-flex gap-2">
                <input
                  className="mb-2"
                  type={"checkbox"}
                  onClick={() => handleCheckbok(1)}
                  checked={couple_friendly == 1}
                />
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Couple Friendly
                </label>
              </div>
              {/* {policy_rules?.length == 0 && policy_rulesErr && (
                <p className="err">Enter Policy Rules</p>
              )} */}
            </div>

            <div className="col-md-6 mb-3">
              <div className="form-group d-flex gap-2">
                <input
                  className="mb-2"
                  type={"checkbox"}
                  onClick={() => handleCheckbok(2)}
                  checked={family_friendly == 1}
                />
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Get-To-Gether
                </label>
              </div>
              {/* {policy_rules?.length == 0 && policy_rulesErr && (
                <p className="err">Enter Policy Rules</p>
              )} */}
            </div>

            <div className="col-md-6 mb-3 text-center">
              <button
                className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
                onClick={() => submitHandler()}
                disabled={btn}
              >
                Save
              </button>
            </div>
          </Row>
          {types == "edit" && (
            <Row>
              <h2 class="content-heading">
                Property{" "}
                <small>
                  <code class="text-lowercase">Images</code>
                </small>
              </h2>
              <div className="d-flex gap-3 mb-5">
                <div className="col-md-4 mx-3">
                  {singleImg ? (
                    <div className={"mt-2"}>
                      <div className="text-end" onClick={() => setModal(true)}>
                        <FiEdit fontSize={20} className="text-primary" />
                      </div>
                      <ProductZoom image_url={singleImg} />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="d-flex gap-3 mb-5">
                <div className="col-md-4 mx-3">
                  {multiImg?.map((item, ind) => {
                    return (
                      <div key={ind} className={"mt-2"}>
                        <div
                          className="text-end"
                          onClick={() => deleteFun(item?.id)}
                        >
                          <TiDeleteOutline
                            fontSize={23}
                            className="text-danger"
                          />
                        </div>
                        <ProductZoom image_url={item?.image} />
                      </div>
                    );
                  })}
                </div>
              </div>
            </Row>
          )}
        </div>
      </div>

      <Modal
        show={modal}
        onHide={() => {
          setModal(false);
        }}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
      >
        <div className="p-4">
          <Row>
            <div className="d-flex ac-jb">
              <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20">
                Edit Image
              </label>
              <button className="cust-btn" onClick={() => setModal(false)}>
                <CloseIcon />
              </button>
            </div>
          </Row>
          <Row>
            <div className="col-md-12 mb-3 p-3 mt-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Upload Images 307 X 207 (pixel)
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setImg(e.target.files[0])}
                  type={"file"}
                  accept="image/jpeg, image/png"
                />
              </div>
              {img?.length == 0 && imgErr && (
                <p className="err">Upload Images</p>
              )}
            </div>
            <div className="text-center mt-4 mb-4">
              <button
                className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
                onClick={() => saveImg()}
                disabled={btn}
              >
                Save
              </button>
            </div>
          </Row>
        </div>
      </Modal>
    </div>
  );
};

export default PropertyRequestPage;
